import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'
import {
  CostCenterForSelectFragment,
  CostCenterSelectorDocument,
  CostCenterSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

import { EntityFilter } from 'modules/finance/components/FinancialWorkspacePayroll/components/Filters/EntityFilter'

import type { CostCenterSelectorProps } from './types'

const Item = ({ costCenter }: { costCenter: CostCenterForSelectFragment }) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center" key={costCenter.id}>
      <Text.Normal size="300">
        {costCenter.code ? `${costCenter.code} - ${costCenter.name}` : costCenter.name}
      </Text.Normal>
    </Box>
  )
}

export const CostCenterSelector = (props: CostCenterSelectorProps) => {
  const {
    error,
    mandatory,
    label,
    width,
    minWidth,
    emptyLabel,
    filter = false,
    defaultOpen,
    alwaysOpen = filter,
    hideBorder = filter,
    disabled = false,
  } = props

  const renderEntity = (entity: CostCenterForSelectFragment) => <Item costCenter={entity} />

  const renderSkeleton = () => {
    return (
      <Box gap="s8" flexDirection="row" alignItems="center">
        <Skeleton width="s240" height="s32" />
      </Box>
    )
  }

  const extractConnection = (data: CostCenterSelectorQuery) => {
    return data.costCenters.costCentersConnection
  }

  const filterEntities = (entities: CostCenterForSelectFragment[]) => entities

  const document = CostCenterSelectorDocument

  const renderMultipleEntities = (entities: CostCenterForSelectFragment[]) => {
    if (filter) return <></>

    return (
      <Text.Normal>
        {entities.length > 0
          ? entities
              .map((entity) => (entity.code ? `${entity.code} - ${entity.name}` : entity.name))
              .join(', ')
          : (emptyLabel ?? i18n.t('bookkeepers.incidence.filters.types.cost_center'))}
      </Text.Normal>
    )
  }

  const selector = (
    <EntitySelector.Multiple
      label={filter ? undefined : label}
      disabled={disabled}
      error={error}
      mandatory={mandatory}
      alwaysOpen={alwaysOpen}
      hideBorder={hideBorder}
      document={document}
      variables={{}}
      width={width}
      minWidth={minWidth}
      extractConnection={extractConnection}
      renderEntity={renderEntity}
      value={props.value ?? []}
      onChange={props.onChange}
      renderSkeleton={renderSkeleton}
      renderValue={renderMultipleEntities}
      filterEntities={filterEntities}
    />
  )

  if (filter) {
    return (
      <EntityFilter
        value={props.value ?? []}
        onChange={props.onChange}
        defaultOpen={defaultOpen}
        label={label ?? i18n.t('bookkeepers.incidence.filters.types.cost_center')}
      >
        {selector}
      </EntityFilter>
    )
  }

  return selector
}
